<template>
    <div class="card mb-4">
           <div class="card-body row mb-3">
                <div class=" col-md-3 form-group">
                    <label>شماره ترمینال</label>
                    <input type="number"  class="form-control w-100" v-model="terminalId">
                </div>
                <div class="col-6 mt-3" style="display: flex; align-items: center;">
                    <button class="btn btn-primary btn-block " style="width: 200px;" @click="getData" >
                        <i class="si si-magnifier"></i>
                        جستجو
                    </button>
                </div>
            </div>
            <div class="card-body">
                <router-link :to="{name: 'mosque.create'}" class="btn btn-warning mb-3">اتصال کارت به پایانه</router-link>
                <Loading v-if="showLoading" />
                <DataTable :columns="columns" :rows="rows" v-if="rows.length" :count="count" :url="'MosqueOrganization/ReturnAllTerminalsHistory'" :operations="['mosque',{view: {class: 'info',title: 'ویرایش',icon: 'ti-eye'}}]" />
                <div class="alert alert-info mb-0" v-else>
                    <p class="mb-0">داده ای یافت نشد</p>
                </div>
            </div>
     </div>    
</template>

<script>
export default {
    name: 'Organizations',
    data(){
        return {
            showLoading: true,
            terminalId:null,
            columns: [
                {
                    title: 'عنوان',
                    field: 'title'
                },
                {
                    title: 'پایانه',
                    field: 'id'
                },
                 {
                    title: 'شماره کارت',
                    field: 'cardNumber'
                },
                {
                    title: 'نام پذیرنده',
                    field: 'merchantname'
                }
            ],
            rows: [],
            count: 0
        }
    },
    methods: {
        getData(){
            this.rows =[];
            this.$api.post('MosqueOrganization/ReturnAllTerminalsHistory',{perPage: 10,page: 1 , terminalId: this.terminalId ? Number(this.terminalId) : null}).then(({data}) => {
                if(data.status){
                    this.rows = data.result.list.map(terminal => {
                        let newTerminal = {...terminal};
                        if(terminal.terminalInfo){
                            newTerminal.id = terminal.terminalInfo.terminal_number;
                            newTerminal.title =  terminal.terminalInfo.last_name;
                            newTerminal.merchantname=  terminal.terminalInfo.merchant_name;
                        }
                        if(terminal.cards.length > 0){
                            newTerminal.cardNumber = terminal.cards[0].card ;
                        }
                        return newTerminal;
                    });
                    this.count = data.result.totalCount;
                    this.rows.operations = ['mosque',{view: {class: 'info',title: 'ویرایش',icon: 'ti-eye'} , target :"_blank"}];
                }
            }).finally(() => {
                this.showLoading = false;
            });
        }
    },
    created(){
        this.getData();
    }
}
</script>